module.exports = __webpack_public_path__ + "static/img/CameronSmith.150dad1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/CameronSmith.jpg
// module id = 4q2I
// module chunks = 0